import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const formatNumber = (value) => {
  const number = Number(value ?? 0);

  if (!Number.isFinite(number)) {
    return "0";
  }

  return Math.floor(number).toLocaleString();
};

const earningItems = [
  {
    icon: "/pieces.png",
    label: "Number of cards owned",
  },
  {
    icon: "/sparks.png",
    label: "Sparks spent",
  },
  {
    icon: "/sparks.png",
    label: "Sparks earned",
  },
  {
    icon: "/battlem.png",
    label: "Battle and win counts",
  },
  {
    icon: "/runes.png",
    label: "Number of runes purchased",
  },
  {
    icon: "/tstar.svg",
    label: "Amount of Telegram Stars spent",
  },
  {
    icon: "/passicon.png",
    label: "OG Pass status",
  },
  {
    icon: "/skinicon.png",
    label: "Skins owned",
  },
  {
    icon: "/trophy2.png",
    label: "Trophy count",
  },
  {
    icon: "/pluspass.png",
    fallbackIcon: "/passicon.png",
    label: "OG Plus Pass status",
  },
  {
    icon: "/arenam.png",
    label: "Current arena",
  },
  {
    icon: "/stats.png",
    label: "Leaderboard rankings",
  },
  {
    icon: "/friends.png",
    label: "Referrals",
  },
  {
    icon: "/iconcheck.png",
    label: "Tasks done",
  },
  {
    icon: "/3dots.png",
    label: "And much more...",
    iconStyle: {
      width: 42,
      height: 12,
      marginBottom: 9,
    },
  },
];

function TapiEarnCard({
  icon,
  fallbackIcon,
  label,
  iconStyle,
}) {
  return (
    <div
      style={{
        minWidth: 0,
        minHeight: 96,
        padding: "8px 5px",
        boxSizing: "border-box",
        borderRadius: 7,
        border: "2px solid rgba(91, 42, 18, 0.92)",
        background:
          "linear-gradient(180deg, rgba(169, 94, 45, 0.96) 0%, rgba(128, 65, 31, 0.96) 100%)",
        boxShadow:
          "inset 0 1px 0 rgba(255,255,255,0.17), 0 2px 2px rgba(0,0,0,0.25)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        overflow: "hidden",
      }}
    >
      <img
        src={icon}
        alt=""
        draggable={false}
        style={{
          width: 48,
          height: 48,
          marginBottom: 4,
          objectFit: "contain",
          filter: "drop-shadow(0 2px 2px rgba(0,0,0,0.45))",
          ...iconStyle,
        }}
        onError={(event) => {
          if (fallbackIcon) {
            event.currentTarget.onerror = null;
            event.currentTarget.src = fallbackIcon;
          } else {
            event.currentTarget.style.display = "none";
          }
        }}
      />

      <div
        className="shadow1"
        style={{
          width: "100%",
          color: "#fff",
          fontSize: 11,
          lineHeight: "12px",
          fontWeight: 800,
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
        }}
      >
        {label}
      </div>
    </div>
  );
}

function EarningHistoryCard({
  season,
  amount,
  ongoing = false,
}) {
  return (
    <div
      style={{
        minWidth: 0,
        minHeight: 128,
        padding: "10px 6px",
        borderRadius: 7,
        border: "2px solid rgba(91, 42, 18, 0.92)",
        background:
          "linear-gradient(180deg, rgba(169, 94, 45, 0.94) 0%, rgba(126, 63, 29, 0.94) 100%)",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <img
        src="/icon_tapi.png"
        alt=""
        draggable={false}
        style={{
          width: 62,
          height: 62,
          objectFit: "contain",
          marginBottom: 5,
          filter: "drop-shadow(0 3px 2px rgba(0,0,0,0.42))",
        }}
      />

      <div
        className="shadow1"
        style={{
          color: "#fff",
          fontSize: 15,
          lineHeight: "17px",
          fontWeight: 800,
        }}
      >
        {season}
      </div>

      <div
        className="shadow1"
        style={{
          color: ongoing ? "#72ff50" : "#fff22e",
          fontSize: ongoing ? 18 : 18,
          lineHeight: "21px",
          fontWeight: 600,
          marginTop: 3,
          whiteSpace: "nowrap",
        }}
      >
        {ongoing ? "On Going..." : formatNumber(amount)}
      </div>
    </div>
  );
}

export default function MyTapisPage({
  open = true,
  user,
  setUser,
  onClose,
}) {
  const tapiAmount = Math.floor(Number(user?.tapi || 0));

  const [airdropStats, setAirdropStats] = useState(null);
  const [loadingAirdrop, setLoadingAirdrop] = useState(false);
  const [airdropError, setAirdropError] = useState("");

  const [claimingAirdrop, setClaimingAirdrop] = useState(false);
  const [claimAirdropError, setClaimAirdropError] = useState("");
  const [claimAirdropSuccess, setClaimAirdropSuccess] = useState("");

  const [nowMs, setNowMs] = useState(Date.now());

  useEffect(() => {
    if (!open) return;

    let cancelled = false;

    async function loadAirdrop() {
      const token = localStorage.getItem("token");

      if (!token) {
        setAirdropError("Missing token");
        return;
      }

      try {
        setLoadingAirdrop(true);
        setAirdropError("");

        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/airdrops`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const text = await res.text();

        let data = {};

        try {
          data = text ? JSON.parse(text) : {};
        } catch {
          data = {};
        }

        if (!res.ok) {
          throw new Error(
            data?.error || "Failed to load airdrop information"
          );
        }

        if (!cancelled) {
          setAirdropStats(data);
        }
      } catch (err) {
        console.error("Failed to load airdrop:", err);

        if (!cancelled) {
          setAirdropError(
            err.message || "Failed to load airdrop information"
          );
        }
      } finally {
        if (!cancelled) {
          setLoadingAirdrop(false);
        }
      }
    }

    loadAirdrop();

    return () => {
      cancelled = true;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;

    setNowMs(Date.now());

    const id = setInterval(() => {
      setNowMs(Date.now());
    }, 1000);

    return () => clearInterval(id);
  }, [open]);

  function parseDateMs(value) {
    if (!value) return null;

    const ms = new Date(value).getTime();

    return Number.isFinite(ms) ? ms : null;
  }

  function formatCountdown(ms) {
    const total = Math.max(0, Math.floor(ms / 1000));

    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;

    if (days > 0) {
      return `${days}d ${String(hours).padStart(2, "0")}h ${String(
        minutes
      ).padStart(2, "0")}m`;
    }

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  }

 const airdropAlreadyClaimed =
  Boolean(
    airdropStats?.airdropClaim &&
    (
      airdropStats.airdropClaim.claimed === true ||
      airdropStats.airdropClaim.claimedAt ||
      airdropStats.airdropClaim.claimed_at ||
      airdropStats.airdropClaim.id
    )
  );

  const claimStartsAtMs = parseDateMs(
    airdropStats?.claimStartsAt
  );

  const claimEndsAtMs = parseDateMs(
    airdropStats?.claimEndsAt
  );

  const claimNotStarted =
    claimStartsAtMs != null && nowMs < claimStartsAtMs;

  const claimEnded =
    claimEndsAtMs != null && nowMs > claimEndsAtMs;

  const claimLive =
    !claimNotStarted && !claimEnded;

  const claimStartsInMs =
    claimNotStarted && claimStartsAtMs != null
      ? Math.max(0, claimStartsAtMs - nowMs)
      : 0;

  const claimEndsInMs =
    claimLive && claimEndsAtMs != null
      ? Math.max(0, claimEndsAtMs - nowMs)
      : 0;

  const claimableTapi = Math.floor(
    Number(airdropStats?.totals?.overall || 0)
  );

  async function handleClaimAirdrop() {
    if (claimingAirdrop) return;
    if (airdropAlreadyClaimed) return;
    if (!claimLive) return;

    const token = localStorage.getItem("token");

    if (!token) {
      setClaimAirdropError("Missing token");
      return;
    }

    try {
      setClaimingAirdrop(true);
      setClaimAirdropError("");
      setClaimAirdropSuccess("");

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/airdrops/claim`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const text = await res.text();

      let data = {};

      try {
        data = text ? JSON.parse(text) : {};
      } catch {
        data = {};
      }

      if (!res.ok) {
        /*
         * If another screen/session claimed it already,
         * refresh the state instead of allowing another claim.
         */
        if (res.status === 409) {
          setAirdropStats((prev) => ({
            ...(prev || {}),
            airdropClaim: {
              claimed: true,
              claimedAt:
                data?.claimedAt || new Date().toISOString(),
            },
          }));

          return;
        }

        throw new Error(
          data?.error || "Failed to claim airdrop"
        );
      }

      const claimedAmount = Number(
        data?.claimedAmount || 0
      );

      const finalTapiBalance = Number(
        data?.tapi ?? claimedAmount
      );

      setUser?.((prev) => ({
        ...(prev || {}),
        tapi: finalTapiBalance,
        hasUnclaimedAirdrop: false,
      }));

      setAirdropStats((prev) => ({
        ...(prev || {}),
        airdropClaim: {
          claimed: true,
          claimedAt:
            data?.claimedAt || new Date().toISOString(),
        },
      }));

      setClaimAirdropSuccess(
        `${formatNumber(claimedAmount)} $TAPI claimed successfully!`
      );
    } catch (err) {
      console.error("Claim airdrop failed:", err);

      setClaimAirdropError(
        err.message || "Failed to claim airdrop"
      );
    } finally {
      setClaimingAirdrop(false);
    }
  }

  return (
    <div>
      {open && (
        <div
          className="modal_box"
          style={{
            zIndex: 100003,
          }}
        >
          <div className="modal_title">
            AIRDROP

            <button
              type="button"
              className="modal_close"
              onClick={onClose}
            />
          </div>

          <motion.div className="modal_body" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.92, opacity: 0 }}>
            <div className="modal_inside_2">
              {/* TAPI POINTS */}
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  minHeight: 127,
                  borderRadius: 9,
                  overflow: "hidden",
                  boxSizing: "border-box",
                  border: "3px solid #713112",
                  background:
                    "linear-gradient(135deg, #ffc73c 0%, #f0a92b 48%, #ffd44b 100%)",
                  boxShadow:
                    "inset 0 1px 0 rgba(255,255,255,0.42), 0 3px 0 rgba(70,25,5,0.32)",
                  display: "flex",
                  alignItems: "center",
                  padding: "12px 13px",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    opacity: 0.16,
                    background:
                      "repeating-linear-gradient(125deg, transparent 0 34px, rgba(255,255,255,0.6) 35px 54px)",
                    pointerEvents: "none",
                  }}
                />

                <img
                  src="/icon_tapi.png"
                  alt=""
                  draggable={false}
                  style={{
                    position: "relative",
                    zIndex: 1,
                    width: 106,
                    height: 106,
                    flex: "0 0 106px",
                    objectFit: "contain",
                    marginRight: 8,
                    filter:
                      "drop-shadow(0 4px 2px rgba(105,42,0,0.42))",
                  }}
                />

                <div
                  style={{
                    position: "relative",
                    zIndex: 1,
                    flex: 1,
                    minWidth: 0,
                    textAlign: "left",
                  }}
                >
                  <div
                    className="shadow2"
                    style={{
                      color: "#fff",
                      fontSize: 23,
                      lineHeight: "28px",
                      fontWeight: 900,
                    }}
                  >
                    $TAPI POINTS
                  </div>

                  <div
                    className="shadow2"
                    style={{
                      color: "#fff32d",
                      fontSize:
                        tapiAmount >= 1000000 ? 36 : 42,
                      lineHeight: "43px",
                      fontWeight: 900,
                      whiteSpace: "nowrap",
                      letterSpacing: "-1px",
                    }}
                  >
                    {formatNumber(tapiAmount)}
                  </div>
                </div>
              </div>

                            {/* UNCLAIMED SEASON AIRDROP */}
              {!loadingAirdrop &&
                airdropStats &&
                !airdropAlreadyClaimed && (
                  <div
                    style={{
                      width: "100%",
                      marginTop: 8,
                      padding: "12px",
                      boxSizing: "border-box",
                      border: "3px solid #6f310e",
                      borderRadius: 9,
                      background:
                        "linear-gradient(180deg, #8f4928 0%, #693319 100%)",
                      boxShadow:
                        "inset 0 1px 0 rgba(255,255,255,0.18), 0 3px 0 rgba(70,25,5,0.25)",
                      textAlign: "center",
                    }}
                  >
                    <div
                      className="shadow1"
                      style={{
                        color: "#fff",
                        fontSize: 20,
                        lineHeight: "24px",
                        fontWeight: 900,
                      }}
                    >
                      SEASON REWARDS
                    </div>

                    <div
                      className="shadow2"
                      style={{
                        color: "#fff32d",
                        fontSize: 28,
                        lineHeight: "34px",
                        fontWeight: 900,
                        marginTop: 4,
                      }}
                    >
                      {formatNumber(claimableTapi)} $TAPI
                    </div>

                    <div
                      className="shadow1"
                      style={{
                        color: "#fff",
                        fontSize: 14,
                        fontWeight: 600,
                        marginTop: 2,
                        marginBottom: 10,
                      }}
                    >
                      Waiting for you to claim
                    </div>

                    <button
                      type="button"
                      className="game-button green-button"
                      onClick={handleClaimAirdrop}
                      disabled={
                        claimingAirdrop ||
                        !claimLive
                      }
                      style={{
                        fontSize: 20,
                        padding: "0 22px",
                        opacity:
                          claimingAirdrop || !claimLive
                            ? 0.65
                            : 1,
                        cursor:
                          claimingAirdrop || !claimLive
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      {claimingAirdrop
                        ? "CLAIMING..."
                        : claimNotStarted
                        ? "CLAIM SOON"
                        : claimEnded
                        ? "CLAIM ENDED"
                        : "CLAIM NOW"}
                    </button>

                    <div
                      className="shadow1"
                      style={{
                        marginTop: 8,
                        fontSize: 14,
                        fontWeight: 600,
                        color: claimNotStarted
                          ? "#ffd66b"
                          : claimEnded
                          ? "#ff8c8c"
                          : "#8cff98",
                      }}
                    >
                      {claimNotStarted
                        ? `Claim Starts In ${formatCountdown(
                            claimStartsInMs
                          )}`
                        : claimEnded
                        ? "Claim Window Ended"
                        : claimEndsAtMs != null
                        ? `Claim Ends In ${formatCountdown(
                            claimEndsInMs
                          )}`
                        : "Claim Is Live Now"}
                    </div>

                    {claimAirdropError && (
                      <div
                        className="shadow1"
                        style={{
                          marginTop: 7,
                          color: "#ff9b9b",
                          fontSize: 13,
                          fontWeight: 600,
                        }}
                      >
                        {claimAirdropError}
                      </div>
                    )}
                  </div>
                )}

              {claimAirdropSuccess && (
                <div
                  className="shadow1"
                  style={{
                    width: "100%",
                    marginTop: 8,
                    padding: "10px",
                    boxSizing: "border-box",
                    borderRadius: 8,
                    background: "rgba(52, 130, 42, 0.88)",
                    border: "2px solid #285d20",
                    color: "#fff",
                    fontSize: 15,
                    fontWeight: 700,
                    textAlign: "center",
                  }}
                >
                  {claimAirdropSuccess}
                </div>
              )}

              {airdropError && (
                <div
                  className="shadow1"
                  style={{
                    marginTop: 7,
                    color: "#ff9b9b",
                    fontSize: 13,
                    fontWeight: 600,
                    textAlign: "center",
                  }}
                >
                  {airdropError}
                </div>
              )}

                          {/* ALLOCATION MESSAGE */}
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  minHeight: 105,
                  marginTop: 7,
                  padding: "12px 10px 10px 88px",
                  boxSizing: "border-box",
                  border: "3px solid #6f310e",
                  borderRadius: 9,
                  background:
                    "linear-gradient(135deg, #6b176c 0%, #b51a79 53%, #64135f 100%)",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src="/v2/taskchar.png"
                  alt=""
                  draggable={false}
                  style={{
                    position: "absolute",
                    left: -5,
                    bottom: -18,
                    width: 105,
                    height: 130,
                    objectFit: "contain",
                    objectPosition: "left bottom",
                  }}
                />

                <div
                  className="shadow1"
                  style={{
                    position: "relative",
                    zIndex: 1,
                    color: "#fff",
                    fontSize: 16,
                    lineHeight: "28px",
                    fontWeight: 600,
                    textAlign: "left",
                  }}
                >
                  These points will determine
                  <br />

                  <span
                    style={{
                      color: "#eeff32",
                      fontSize: 21,
                    }}
                  >
                    Your Future $TAPI
                    <br />
                    Allocation!
                  </span>
                </div>
              </div>

{/* EARNING HISTORY */}
{(!claimLive || airdropAlreadyClaimed) && (
  <div
    style={{
      width: "100%",
      marginTop: 10,
      borderRadius: 9,
      overflow: "hidden",
      border: "3px solid #6f310e",
      boxSizing: "border-box",
    }}
  >
    <div
      className="shadow1"
      style={{
        height: 43,
        padding: "0 13px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        color: "#fff",
        fontSize: 21,
        lineHeight: "23px",
        fontWeight: 900,
        textAlign: "left",
        background:
          "linear-gradient(180deg, #9b4b28 0%, #79371c 100%)",
        borderBottom: "3px solid #6f310e",
      }}
    >
      Earning History
    </div>

    <div
      style={{
        padding: 10,
        background:
          "linear-gradient(180deg, rgba(173,100,50,0.97) 0%, rgba(143,75,36,0.97) 100%)",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          gap: 8,
        }}
      >
        <EarningHistoryCard
          season="Season 1 & 2"
          amount={tapiAmount}
        />

        <EarningHistoryCard
          season="Season 3"
          ongoing
        />
      </div>
    </div>
  </div>
)}

              {/* HOW YOU EARN */}
              <div
                style={{
                  width: "100%",
                  marginTop: 10,
                  borderRadius: 9,
                  overflow: "hidden",
                  border: "3px solid #6f310e",
                  boxSizing: "border-box",
                }}
              >
                <div
                  className="shadow1"
                  style={{
                    minHeight: 43,
                    padding: "8px 13px",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                    fontSize: 20,
                    lineHeight: "23px",
                    fontWeight: 900,
                    textAlign: "left",
                    background:
                      "linear-gradient(180deg, #9b4b28 0%, #79371c 100%)",
                    borderBottom: "3px solid #6f310e",
                  }}
                >
                  How You Earn $TAPI Points?
                </div>

                <div
                  style={{
                    padding: 7,
                    background:
                      "linear-gradient(180deg, rgba(173,100,50,0.97) 0%, rgba(143,75,36,0.97) 100%)",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(3, minmax(0, 1fr))",
                      gap: 7,
                    }}
                  >
                    {earningItems.map((item, index) => (
                      <TapiEarnCard
                        key={`${item.label}-${index}`}
                        {...item}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal_footer">
              <button
                type="button"
                className="game-button yellow-button" style={{paddingLeft: 35,marginRight: 10}}
              >
                <img src="/v2/lock.png" style={{left: 10,position: "absolute",height: 24}}/> AIRDROP (TBA)
              </button>

              <button
                type="button"
                onClick={onClose}
                className="game-button red-button"
              >
                CLOSE
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
}